import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=ee731aca&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee731aca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee731aca')) {
      api.createRecord('ee731aca', component.options)
    } else {
      api.reload('ee731aca', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=ee731aca&scoped=true&", function () {
      api.rerender('ee731aca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2d2e2SgEypq8J/JS/comp/Accordion.vue"
export default component.exports